
<ng-template #template let-anchor>
  <pre>{{ anchor.nativeElement.getAttribute("data-tooltip") }}</pre>
</ng-template>
<div class='grid-wrapper'>
  <kendo-grid
    class="connections"
    [data]="view"

    [sort]="state.sort"
    [sortable]="true"
    [filter]="state.filter"
    filterable="menu"
    (detailExpand)="detailExpanded($event)"
    (dataStateChange)="dataStateChange($event)"
    [scrollable]="'virtual'"
    [rowHeight]="32"
    [pageSize]="state.take"
    [skip]="state.skip"

    #connectionsgrid
    >
    <kendo-grid-column field="name" title="Name" [width]="200" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div style="align-self:flex-start;min-width: 0; overflow: hidden; text-overflow: ellipsis;">
          <a href="{{this.apiRoot}}/environments/{{dataItem.environment}}/connections?apiName={{dataItem.connector}}&connectionName={{dataItem.name}}"
            [title]="dataItem.name" target="_blank">
            <!-- Removed `title="{{ dataItem.raw | json }}"` — eagerly stringifying every connection's
            raw payload into a DOM attribute is the primary OOM cause on large tenants. The full
            raw blob is still available via "View Connector JSON" in the row context menu. -->
            <span>{{dataItem.name}}</span>
          </a>
        </div>
      </ng-template>
      <ng-template kendoGridFooterTemplate let-column="column">
        <span title='Total Connections'>{{this.connections.length}}&nbsp;</span>
        @if (this.loading$ | async) {
          <span><span class='k-icon k-i-loading' title='loading connections'></span>...</span>
        }
        @if (this.adminLoading$ | async) {
          <span><span class='k-icon k-i-loading' title='loading admin connections'></span> admin&hellip;</span>
        }
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="status" title="Status" [width]="50" class="cell">
      <!-- <ng-template kendoGridCellTemplate let-dataItem>
      <span *ngIf="dataItem.status=='Succeeded'" class='k-icon k-i-check-circle' style='color:green;' title='Succeeded'></span>
      <span *ngIf="dataItem.status=='Failed'" class='k-icon k-i-close-circle' style='color:firebrick;' title='Failed'></span>
      <span *ngIf="dataItem.status=='Running'" class='k-icon k-i-video-external' style='color:dodgerblue;' title='Running'></span>
      <span *ngIf="dataItem.status=='Cancelled'" class='k-icon k-i-minus-circle' style='color:gray' title='Cancelled'></span>
      <span style='margin-left:5px;' title="{{ dataItem.status }}">{{dataItem.status}}</span>
    </ng-template> -->

  </kendo-grid-column>
  <kendo-grid-column field="displayName" title="Display" [width]="100" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem>
      <img [src]='this.getSafeUrl(dataItem.iconUri)' (error)="dataItem.badIconUri()" style='width:20px; height:20px; vertical-align:middle; background-color:#007ee5;' />
      <!-- https://australia.flow.microsoft.com/en-us/connectors/shared_flow.2dfull.5fc86363ad2d36e4db.5f1d82e68879da53fe/flow-full/ -->
      <span title="{{ dataItem.apiId }}">&nbsp;{{dataItem.displayName}}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="connectorUri" title="Connector" [width]="100" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span title="{{ dataItem.apiId }}">&nbsp;<a href='{{this.apiRoot}}/en-us/connectors/{{dataItem.connector}}' target='_blank'>{{dataItem.connector}}</a></span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="createdTime" title="Created" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="80" class="cell">
  </kendo-grid-column>
  <kendo-grid-column field="lastModifiedTime" title="Modified" type="date" format="{0:y-MM-dd HH:mm:ss a}" filter="date" [width]="80" class="cell">
  </kendo-grid-column>
  <kendo-grid-column field="age" title="Age" type="number" format="{0:g}" [width]="100" class="cell">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.age) {
        <span title='{{dataItem.ageString}}'>{{dataItem.age}} ({{dataItem.ageString}})</span>
      }
    </ng-template>
  </kendo-grid-column>

  <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="this.hasConnections">
    <kendo-grid
      [data]="dataItem.connections"
      >
      <kendo-grid-column field="name" title="Flow Name" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          <!-- Same removal as parent grid: don't stringify raw into a tooltip per row. -->
          <span>{{dataItem.name}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="displayName" title="Display" [width]="100" class="cell">
      </kendo-grid-column>
    </kendo-grid>
  </ng-template>

  <kendo-grid-excel fileName="runs.xlsx"></kendo-grid-excel>
  <ng-template kendoGridLoadingTemplate>
    <div class="k-loading-color"></div>
    <div class="loading-container">
      <kendo-loader type="converging-spinner" size="large"></kendo-loader>
    </div>
  </ng-template>
  <ng-template kendoGridNoRecordsTemplate>
    @if (this.token_pa) {
      <p>No records available.</p>
    }
    @if (!this.token_pa) {
      <p>No records available.  Permission not available: <button kendoButton (click)="loginPowerAppConsent()">Click to grant permission to Power Platform API</button></p>
    }
  </ng-template>
</kendo-grid>
<!-- <div *ngIf="!this.ready" class="k-i-loading"></div> -->
<grid-context-menu [for]="connectionsgrid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" (select)="onSelect($event)">
</grid-context-menu>
</div>